<template>
    <div>
        <navigation-bar Back/>
        <div class="main container" ref="BigMain" @scroll="scrollEvent">

            <div class="no-data" v-if="fromList.length===0">
                <img src="@/assets/images/empty.svg">
                <p>OH！目前空空的</p>
            </div>
            <div v-for="(item,index) in fromList" :key="index" @click="onClickForm(item.id)" class="store d-flex">
                <el-image class="avatar" :src="item.imagePath" fit="cover"/>
                <div class="name">
                    <div class="date">{{item.updatedAt}}</div>
                    <div class="text">{{item.formName}}</div>
                    <div class="brand">{{item.organizer}}</div>
                </div>
                <div class="more">
                    <i class="el-icon-arrow-right"/>
                </div>
            </div>


            <infinite-loading :identifier="infiniteId" slot="append" spinner="waveDots" @infinite="setupData" ref="infiniteLoading">
                <div slot="no-more">沒有更多資料</div>
                <span slot="no-results"/>
            </infinite-loading>

        </div>
    </div>
</template>

<script>

    import * as constDefine from "@/store/constDefine";

    export default {
        name: "Form",
        components: {},
        data() {
            return {
                fromList:[],
                offset: 0,
                pageSize: 10,
                infiniteId: 0,      //下拉載入 觸發
                scrollPosition: 0,     //捲動紀錄定位
                timeoutID: 0,
            }
        },
        created() {

        },
        activated(){

        },
        mounted() {

            this.infiniteId++;
            // this.$refs.BigMain.scrollTop = this.scrollPosition;
            // // this.$refs.BigMain.scrollTo(this.scrollPosition, 0);
            // console.log(`mounted BigMain.scrollTop: ${JSON.stringify(this.$refs.BigMain.scrollTop)}, scrollPosition: ${this.scrollPosition}`);

            // 渲染完成後等一下才捲到目標位置
            this.$nextTick(function () {
                if (this.scrollPosition !== '') {
                    let finish = false;
                    let count = 0;
                    this.timeoutID = setInterval(() => {
                        this.$refs.BigMain.scrollTop = this.scrollPosition;

                        this.scrollPosition = '';
                        finish = true;
                        count = count + 1;
                        if (finish || count>4) {
                            window.clearInterval(this.timeoutID);
                        }
                        // console.log(`mounted BigMain.scrollTop: ${JSON.stringify(this.$refs.BigMain.scrollTop)}, scrollPosition: ${this.scrollPosition}`);
                    }, 100);
                }
            });
        },
        methods: {

            /** 取資料 */
            setupData($state) {
                let self = this;
                this.isLoading = true;
                // console.log(`itemList: ${JSON.stringify(itemList)}`);

                self.$http.fetchWithAuth`GetFormRecordList${{
                    offset: self.offset,
                }} ${json => {
                    if (json.status) {
                        if (json.data.length >= this.pageSize) {
                            this.offset++;
                            this.fromList.tmz_load_push(...json.data);
                            $state.loaded();
                        } else {
                            this.offset++;
                            this.fromList.tmz_load_push(...json.data);
                            $state.complete();
                        }
                    }
                    this.isLoading = false;
                }}`
            },

            //捲動紀錄位置
            scrollEvent() {
                // const fullWidth = window.innerWidth;
                // if(fullWidth>=1024){
                    //網頁版紀錄捲動位置
                    this.scrollPosition = this.$refs.BigMain.scrollTop;
                    // console.log(`scrollPosition: ${JSON.stringify(this.scrollPosition)}`);
                // }
            },

            /** 跳往表格詳細頁 */
            onClickForm: function(id) {
                let dataToken = this.cryptDataToken({"id": id});
                this.$router.push({name:'FormContent', query:{ "dataToken": dataToken}});
            },

            /** 組裝 dataToken */
            cryptDataToken: function(item) {
                return this.$crypto.objectToURIComponent(item) ;
            },
        },
    }
</script>
<style lang="less" scoped>
    .store {
        padding: 20px 10px;
        border-bottom: 1px solid #e0e0e0;
        align-items: center;
        a{
            width: 100%;
            @media(min-width: 1024px){
                display: flex;
            }
        }
        .avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 16px;
        }
        .name {
            flex: 1;
            .text {
                font-size: 16px;
                color: #6F5B62;
                overflow:hidden;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
            }
            .date{
                font-size: 12px;
                line-height: 15px;
            }
            .brand {
                overflow:hidden;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                font-weight: 600;
                font-size: 13px;
                line-height: 15px;
            }
        }
    }
</style>